import { Observable } from "rxjs/Observable";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject, Subscription } from "rxjs/Rx";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { debounceTime } from "rxjs/operator/debounceTime";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "../shared/services/auth.service";
import * as firebase from "firebase/app";
import { BackendService } from "../shared/services/backend.service";
import { NoticeBoardService } from "./../shared/services/notice-board/notice-board.service";
import { AccountService } from "../shared/account/account.service";
import { CommunityService } from "../shared/services/community/community.service";
import { Bulletin } from "./../shared/services/notice-board/bulletin";
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';


@Component({
  selector: "app-notice-board",
  templateUrl: "./notice-board.component.html",
  styleUrls: ["./notice-board.component.css"]
})
export class NoticeBoardComponent implements OnInit, OnDestroy {
  private _alert: Subject<string> = new Subject<string>();
  private alertSubscription: Subscription = new Subscription();
  activeRouteIndex: number;
  routeSubscription: Subscription;
  community: any;
  bulletin: Bulletin;
  bulletins = [];
  confirmationMessage = "";
  confirmationTitle = "";
  modalReference: NgbModalRef;
  successMessage = "";
  errorMessage = "";
  private authState: firebase.User | null;
  userId: string;
  hasNoTitle = false;
  hasNoBody = false;
  query = "";
  public Editor = ClassicEditor;

  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private authService: AuthService,
    private accountService: AccountService,
    private noticeBoardService: NoticeBoardService,
    private communityService: CommunityService
  ) {
    this.authState = this.authService.getAuthState();
    this.userId = BackendService.generateUserId(this.authState.email);
    this.community = {};
  }

  ngOnInit(): void {
    this.routeSubscription = this.route.params.subscribe(
      params => (this.activeRouteIndex = params.index)
    );
    this.accountService.getActiveRoleDetails().then((role: any) => {
      this.noticeBoardService.getBulletins(role.communityId).subscribe(
        bulletins => {
          this.bulletins = bulletins;
        }
      );
      this.communityService
        .getCommunityById(role.communityId)
        .subscribe(community => {
          this.community = community;
        });
    });
    this.bulletin = new Bulletin();
  }

  ngOnDestroy(): void {
    this.closeModal();
    this.routeSubscription.unsubscribe();
  }

  showAlert(msgType, msg): void {
    this.alertSubscription = this._alert.subscribe(message => {
      msgType ? (this.successMessage = message) : (this.errorMessage = message);
    });
    debounceTime.call(this._alert, 3000).subscribe(() => {
      msgType
        ? (this.successMessage = undefined)
        : (this.errorMessage = undefined);
    });
    this._alert.next(msg);
    this.alertSubscription.unsubscribe();
  }

  openModal(modal, modalSize): void {
    if (!modalSize) {
      this.modalReference = this.modalService.open(modal);
    } else {
      this.modalReference = this.modalService.open(modal, { size: modalSize });
    }
  }

  closeModal(): void {
    if (this.modalReference) {
      this.modalReference.close();
    }
  }

  showViewModal(modal, bulletin): void {
    this.bulletin = bulletin;
    this.openModal(modal, null);
  }

  confirmDelete(bulletin, modal): void {
    const message = `Are you sure you want to delete ${bulletin.title}?`;
    this.bulletin = bulletin;
    this.confirm("Delete Bulletin!", message, modal);
  }

  confirm(title, message, modal): void {
    this.confirmationTitle = title;
    this.confirmationMessage = message;
    this.closeModal();
    this.openModal(modal, "sm");
  }

  deleteBulletin(): void {
    this.noticeBoardService.delete(this.community.id, this.bulletin.id);
    this.closeModal();
    this.bulletin = new Bulletin();
    this.showAlert(true, "Bulletin deleted successfully.");
  }

  saveBulletin(bulletin): void {
    let forCreate = true;
    bulletin.title = bulletin.title.trim();
    bulletin.body = bulletin.body.trim();

    if (!bulletin.title) {
      this.hasNoTitle = true;

      return;
    }
    if (!bulletin.body) {
      this.hasNoBody = true;

      return;
    }

    if (bulletin.id) {
      forCreate = false;
      this.noticeBoardService.update(this.community.id, bulletin);
    } else {
      const date = new Date();
      bulletin.timestamp = date.getTime();
      bulletin.authorId = this.userId;
      bulletin.author = this.authState.displayName;
      bulletin.communityId = this.community.id;
      this.noticeBoardService.create(this.community.id, bulletin);
    }

    this.closeModal();
    this.noticeBoardService.getBulletins(this.community.id).subscribe(
     bulletins => this.bulletins = bulletins
   );
    this.showAlert(
      true,
      forCreate
        ? "Bulletin created successfully."
        : "Bulletin updated successfully."
    );
  }

  createOrEditBulletin(modal, bulletin: any): void {
    this.hasNoBody = this.hasNoTitle = false;
    if (!bulletin) {
      this.bulletin = new Bulletin();
    } else {
      this.closeModal();
    }
    this.openModal(modal, null);
  }
}



// WEBPACK FOOTER //
// ./src/app/notice-board/notice-board.component.ts